(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["intag-homepage-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const boot = () => {
    const config = document.querySelector('meta[name="intag-homepage-motion"]');
    const main = document.getElementById('main');
    if (!config || !main || window.intagHomepageMotion) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = matchMedia('(max-width: 999px)');
    const rows = new Map();
    const sections = new Map();
    const reveals = new Set();
    const duration = Math.min(600, Math.max(400, Number(config.dataset.duration) || 500));

    class ProductRow {
      constructor(root) {
        this.root = root;
        this.track = root.querySelector('[data-intag-track]');
        this.controls = root.querySelector('[data-intag-controls]');
        if (!this.track || !this.controls) return;
        this.originals = Array.from(this.track.children);
        this.prev = root.querySelector('[data-intag-prev]');
        this.next = root.querySelector('[data-intag-next]');
        this.holds = new Set();
        this.visible = false;
        this.requested = this.defaultAutoplay();
        this.speed = Math.min(40, Math.max(8, Number(root.dataset.speed) || 18));
        this.direction = root.dataset.direction === 'right' ? -1 : 1;
        this.abort = new AbortController();
        this.frame = null;
        this.lastTime = null;
        this.on = (node, name, fn, opts = {}) => node.addEventListener(name, fn, {...opts, signal: this.abort.signal});
        this.on(root, 'focusin', e => this.hold('focus', e.target.matches(':focus-visible')));
        this.on(root, 'focusout', () => queueMicrotask(() => this.hold('focus', root.contains(document.activeElement) && document.activeElement.matches(':focus-visible'))));
        this.on(this.prev, 'click', () => this.navigate(-1));
        this.on(this.next, 'click', () => this.navigate(1));
        this.on(this.track, 'pointerdown', e => {
          this.hold('pointer', true);
          if (e.pointerType === 'mouse') this.stopManual();
        }, {passive: true});
        this.on(window, 'pointerup', () => this.hold('pointer', false), {passive: true});
        this.on(window, 'pointercancel', () => this.hold('pointer', false), {passive: true});
        this.on(this.track, 'touchstart', e => {
          const t = e.touches[0];
          if (t) this.touch = {x: t.clientX, y: t.clientY};
          this.hold('touch', true);
        }, {passive: true});
        this.on(this.track, 'touchmove', e => {
          const t = e.touches[0];
          if (t && this.touch && Math.abs(t.clientX - this.touch.x) > 8 && Math.abs(t.clientX - this.touch.x) > Math.abs(t.clientY - this.touch.y)) this.stopManual();
        }, {passive: true});
        const endTouch = () => { this.touch = null; this.hold('touch', false); };
        this.on(this.track, 'touchend', endTouch, {passive: true});
        this.on(this.track, 'touchcancel', endTouch, {passive: true});
        this.on(this.track, 'wheel', e => { if (Math.abs(e.deltaX) > 2 || e.shiftKey) this.stopManual(); }, {passive: true});
        this.on(this.track, 'keydown', e => {
          if (e.target !== this.track) return;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigate(e.key === 'ArrowLeft' ? -1 : 1);
          } else if (e.key === 'Home' || e.key === 'End') {
            e.preventDefault();
            this.stopManual();
            this.track.scrollTo({left: e.key === 'Home' ? 0 : this.track.scrollWidth, behavior: reduced.matches ? 'instant' : 'smooth'});
          }
        });
        this.on(this.track, 'scroll', () => { if (!this.running) this.updateButtons(); }, {passive: true});
        this.on(document, 'visibilitychange', () => this.update());
        this.on(mobile, 'change', () => {
          this.requested = this.defaultAutoplay();
          this.measure();
        });
        this.on(reduced, 'change', () => this.update());
        if ('ResizeObserver' in window) {
          this.resize = new ResizeObserver(() => this.measure());
          this.resize.observe(this.track);
        } else this.on(window, 'resize', () => this.measure());
        if ('IntersectionObserver' in window) {
          this.intersection = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.update();
          }, {threshold: 0});
          this.intersection.observe(root);
        }
        this.measure();
        root.dataset.intagReady = 'true';
      }
      defaultAutoplay() {
        return mobile.matches ? this.root.dataset.mobileAutoplay === 'true' : this.root.dataset.autoplay === 'true';
      }
      hold(reason, active) {
        active ? this.holds.add(reason) : this.holds.delete(reason);
        this.update();
      }
      measure() {
        const first = this.track.children[0];
        const second = this.track.children[1];
        this.step = second ? second.offsetLeft - first.offsetLeft : 0;
        this.maximum = this.track.scrollWidth - this.track.clientWidth;
        this.overflow = this.maximum > 2;
        this.loopable = this.originals.length > 2 && this.step > 0 && this.maximum >= this.step - 1;
        this.root.dataset.intagLoopable = String(this.loopable);
        this.controls.hidden = !this.overflow;
        this.update();
      }
      updateButtons() {
        const x = this.track.scrollLeft;
        this.prev.disabled = !this.overflow || (!this.loopable && x <= 1);
        this.next.disabled = !this.overflow || (!this.loopable && x >= this.maximum - 1);
      }
      update() {
        if (!this.track) return;
        const allowed = this.loopable && !reduced.matches;
        const desired = this.requested && allowed;
        const run = desired && this.visible && !document.hidden && this.holds.size === 0;
        this.running = run;
        this.root.dataset.intagRunning = String(run);
        this.root.dataset.intagAutoplay = String(desired);
        this.updateButtons();
        if (!run) {
          if (this.frame !== null) cancelAnimationFrame(this.frame);
          this.frame = null;
          this.lastTime = null;
          return;
        }
        if (this.frame === null) {
          this.position = this.track.scrollLeft;
          this.frame = requestAnimationFrame(time => this.tick(time));
        }
      }
      tick(time) {
        this.frame = null;
        if (!this.running || !this.root.isConnected) return;
        const delta = this.lastTime === null ? 0 : Math.min(40, time - this.lastTime);
        this.lastTime = time;
        this.position += this.direction * this.speed * delta / 1000;
        while (this.position >= this.step) {
          this.track.append(this.track.firstElementChild);
          this.position -= this.step;
        }
        while (this.position < 0) {
          this.track.prepend(this.track.lastElementChild);
          this.position += this.step;
        }
        this.track.scrollLeft = this.position;
        this.frame = requestAnimationFrame(nextTime => this.tick(nextTime));
      }
      stopManual() {
        clearTimeout(this.resumeTimer);
        this.hold('navigation', true);
        this.resumeTimer = setTimeout(() => this.hold('navigation', false), 900);
      }
      navigate(direction) {
        this.stopManual();
        let current = this.track.scrollLeft;
        if (this.loopable && direction < 0 && current < this.step) {
          this.track.prepend(this.track.lastElementChild);
          current += this.step;
          this.track.scrollLeft = current;
        } else if (this.loopable && direction > 0 && current + this.step > this.maximum && current >= this.step - 1) {
          this.track.append(this.track.firstElementChild);
          current -= this.step;
          this.track.scrollLeft = current;
        }
        this.track.scrollTo({left: Math.max(0, Math.min(this.maximum, current + direction * this.step)), behavior: reduced.matches ? 'instant' : 'smooth'});
      }
      destroy() {
        clearTimeout(this.resumeTimer);
        this.abort.abort();
        this.resize?.disconnect();
        this.intersection?.disconnect();
        if (this.frame !== null) cancelAnimationFrame(this.frame);
        this.originals.forEach(card => this.track.append(card));
        delete this.root.dataset.intagReady;
      }
    }

    const playReveal = (element, state) => {
      if (state.seen || reduced.matches || config.dataset.reveal !== 'true' || !element.animate) return;
      state.seen = true;
      const header = element.querySelector('.section__header, .intag-why__heading, .intag-how__heading, .intag-faq__heading');
      let targets = Array.from(element.querySelectorAll('.intag-motion-track > .product-item, .promo-block, .intag-shop-card, .intag-why__card, .intag-how__card'));
      if (header) targets.unshift(header);
      if (!targets.length) targets = [element.firstElementChild || element];
      targets = targets.filter(target => {
        const r = target.getBoundingClientRect();
        return r.right > 0 && r.left < innerWidth;
      }).slice(0, 8);
      for (const [i, target] of targets.entries()) {
        try {
          const anim = target.animate([{opacity: 0, transform: 'translateY(14px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration, delay: Math.min(i * 55, 220), easing: 'cubic-bezier(.2,.65,.3,1)', fill: 'backwards'});
          reveals.add(anim);
          anim.finished.catch(() => {}).finally(() => reveals.delete(anim));
        } catch (_) {}
      }
    };
    const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      for (const entry of entries) {
        const state = sections.get(entry.target);
        if (!state) continue;
        if (entry.isIntersecting) playReveal(entry.target, state);
        else if (config.dataset.replay === 'true' && (entry.boundingClientRect.bottom <= 0 || entry.boundingClientRect.top >= innerHeight)) state.seen = false;
      }
    }, {threshold: 0}) : null;
    const init = () => {
      for (const root of main.querySelectorAll('[data-intag-row]')) {
        if (!rows.has(root)) rows.set(root, new ProductRow(root));
      }
      for (const section of main.querySelectorAll(':scope > .shopify-section')) {
        if (sections.has(section) || section.querySelector('[data-section-type="slideshow"]')) continue;
        const r = section.getBoundingClientRect();
        sections.set(section, {seen: r.top < innerHeight && r.bottom > 0});
        revealObserver?.observe(section);
      }
    };
    const cleanup = target => {
      for (const [root, row] of rows) if (target === root || target.contains(root) || !root.isConnected) { row.destroy(); rows.delete(root); }
      for (const section of sections.keys()) if (target === section || target.contains(section) || !section.isConnected) { revealObserver?.unobserve(section); sections.delete(section); }
    };
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', event => cleanup(event.target));
    document.addEventListener('shopify:section:reorder', init);
    for (const type of ['shopify:section:select', 'shopify:block:select', 'shopify:section:deselect', 'shopify:block:deselect']) {
      document.addEventListener(type, event => {
        const selected = !type.endsWith('deselect');
        for (const [root, row] of rows) if (event.target.contains(root) || root.contains(event.target)) row.hold('editor', selected);
        for (const animation of reveals) animation.finish();
      });
    }
    main.addEventListener('focusin', () => { for (const animation of reveals) animation.finish(); });
    reduced.addEventListener('change', () => {
      if (reduced.matches) for (const animation of reveals) animation.cancel();
    });
    window.intagHomepageMotion = {version: '1.0.0'};
    init();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
})();
  } catch(e) { console.error(e); }
})();

})();
